import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';

const {post} = requestWrapper;

const requests = {
	setArtistId: (artistId: number) => {
		const body = new FormData();
		body.append('action', 'POST');
		body.append('params', JSON.stringify({artistId}));
		return post<any>(endpoints.profiles, body, {
			headers: {
				'Content-Type': 'multipart/form-data',
				'x-requested-with': 'xmlhttprequest',
			},
		});
	},
};

export default requests;
